import {useDispatch, useSelector} from "react-redux"
import {IconButton, Tab} from "@mui/material"
import {resetWorkingArticleNoteRelation} from "../../../reducers/workingArticleNoteRelationSlice"
import {Close} from "@mui/icons-material"
import {TabLabel} from "./TabLabel"
import {
	removeTab,
	selectNoteArticleTabsCurrentIndexV2,
	setCurrentTabIndex
} from "../../../reducers/noteArticleTabsV2Slice"
import { clearAttachmentsFromTab } from "../../../reducers/noteAttachmentsSlice"
import {useWorkspaceContext} from "../../../pages/Dashboard"

export function NoteArticleTab(props) {
	const {tab, index} = props // unwrapped here because we pass on the props to MUI's <Tab> component below...
	const dispatch = useDispatch()
	const {workspaceId} = useWorkspaceContext()
	const currentIndex = useSelector(selectNoteArticleTabsCurrentIndexV2)

	const handleRemoveTabClick = (e) => {
		e.preventDefault()
		e.stopPropagation()
		dispatch(removeTab({tabIndex: index, workspaceId}))
		dispatch(clearAttachmentsFromTab({index, workspaceId}))
		if(index === currentIndex){
			dispatch(resetWorkingArticleNoteRelation(workspaceId))
		}
	}

	const setIndex = () => {
		dispatch(setCurrentTabIndex({index, workspaceId}))
	}

	return (
		<Tab
			{...props}
			component={"div"}
			onClick={setIndex}
			variant={"secondaryToolBarTab"}
			sx={{
				zIndex: 10,
				border: tab.singleNote && "1px solid orange",
				borderBottom: "none",
				transition: "background-color 250ms ease-in-out",
				"&:hover": { backgroundColor: "rgba(0, 179, 197, 0.1)" },
			}}
			icon={
				<IconButton
					onClick={handleRemoveTabClick}
					variant={"tab-close"}
				>
					<Close fontSize={"inherit"} />
				</IconButton>
			}
			iconPosition="end"
			label={
				<TabLabel title={tab.title} />
			}
		></Tab>
	)
}
